<style>
    .reminderCalendarInput {
        background-color: rgba(0, 0, 0, 0);
        border-radius: 10px !important;
        border-color: rgba(0, 0, 0, 0.1);
        width: 40%;
        height: 30px;
        padding: 0px 14px;
        font-size: 12px !important;
        -webkit-appearance: none;
    }

    .a-reminderCalendars {
        display: flex;
        align-items: center;
        height: 50px;
        justify-content: space-between;
    }

        .a-reminderCalendars span.badge {
            margin-top: 0px !important;
            position: static !important;
        }

    .card-reminderCalendars {
        box-shadow: none !important;
        border: 1px solid rgba(0, 0, 0, 0.1) !important;
        border-top: none !important;
    }

    .collapse-reminderCalendars {
        max-height: 42vh !important;
        overflow-x: auto !important;
    }
</style>

<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    <span v-if="hasTaskId">جزئیات تکرار وظیفه </span>
                    <span v-else>جزئیات یادآور</span>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="reminderModel.title" @input="v$.reminderModel.title.$touch()" :class="{invalid:v$.reminderModel.title.$error}">
                        <p class="text-danger" v-if="v$.reminderModel.title.required.$invalid && v$.reminderModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                        <p class="text-danger" v-if="v$.reminderModel.title.maxLength.$invalid && v$.reminderModel.title.$dirty">عنوان نباید بیش از ۱۵۰ کاراکتر باشد..</p>

                    </div>

                    <div class="mb-3" id="XXX" style="display:none">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.userId" label="title" placeholder="یادآور برای" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <!--<p class="text-danger" v-if="v$.reminderModel.userId.required.$invalid && v$.reminderModel.userId.$dirty">لطفا یادداشت برای را انتخاب کنید.</p>-->
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.fullTitle }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>


                    <div class="mb-4">
                        <div class="d-flex align-items-center">
                            <label class="w-25 mb-0 text-center font-12">تکرار هر</label>
                            <input class="form-control px-2 w-25 rounded-sm text-center" style="height:35px" type="number" v-model="reminderModel.interval" @input="v$.reminderModel.interval.$touch()" :class="{invalid:v$.reminderModel.interval.$error}" @change="changeCalendar">
                            <v-select class="w-50 mr-2" :class="{invalid:v$.reminderModel.reminderRepeatTypeId.$error}" dir="rtl" label="title" placeholder="نوع تکرار" :filterable="false" :searchable="false" :options="reminderTypeList" :reduce="p => p.reminderRepeatTypeId" v-model="reminderModel.reminderRepeatTypeId" @option:selected="changeCalendar">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                            <label class="w-25 mb-0 text-center font-12">یک بار</label>
                        </div>
                        <p class="text-danger" v-if="v$.reminderModel.interval.required.$invalid && v$.reminderModel.interval.$dirty">لطفا نوع تکرار را وارد کنید.</p>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-check color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.startDate!==null}">تاریخ شروع</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="reminderModel.startDate"
                                   id="startDT"
                                   :class="{invalid:v$.reminderModel.startDate.$error}" />
                        </div>
                        <p class="text-danger" v-if="v$.reminderModel.startDate.required.$invalid && v$.reminderModel.startDate.$dirty">لطفا تاریخ شروع را وارد کنید.</p>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-clock color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.startTime!==null}">ساعت ارسال</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="reminderModel.startTime"
                                   id="startT"
                                   :class="{invalid:v$.reminderModel.startTime.$error}"
                                   :readonly="reminderModel.taskId!=null" />
                        </div>
                        <date-picker type="time" v-model="reminderModel.startTime" :auto-submit="true" format="HH:mm" element="startT" :jumpMinute="5" @change="changeCalendar" v-if="reminderModel.taskId==null" />
                        <p class="text-danger" v-if="v$.reminderModel.startTime.required.$invalid && v$.reminderModel.startTime.$dirty">لطفا ساعت ارسال را وارد کنید.</p>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required mb-3">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.endDate!==null}">تاریخ پایان</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="reminderModel.endDate"
                                   id="endDT" />
                        </div>
                    </div>

                    <div class="checkboxRow mb-3">
                        <div class="fac fac-checkbox fac-green">
                            <span></span>
                            <input id="box3-fac-checkbox" type="checkbox" v-model="reminderModel.onHoliday">
                            <label for="box3-fac-checkbox">ارسال در روزهای تعطیل</label>
                        </div>
                        <div class="fac fac-checkbox fac-orange">
                            <span></span>
                            <input id="box5-fac-checkbox" type="checkbox" v-model="reminderModel.onDayAfterHoliday">
                            <label for="box5-fac-checkbox">ارسال در فردای روز تعطیل</label>
                        </div>
                        <div class="fac fac-checkbox fac-red">
                            <span></span>
                            <input id="box6-fac-checkbox" type="checkbox" v-model="reminderModel.disabled">
                            <label for="box6-fac-checkbox">غیرفعال</label>
                        </div>
                    </div>

                    <div class="card mx-0 mb-3">
                        <div class="list-group list-custom-small list-icon-0 bg-green1-dark px-2 collapse-description-box">
                            <a class="pr-1" data-toggle="collapse" href="#collapse-5">
                                <i class="far fa-calendar"></i>
                                <span>جزئیات تاریخ ارسال</span>
                                <i class="fa fa-angle-down"></i>
                            </a>
                        </div>
                        <div class="collapse pr-3 pl-2 collapse-reminderCalendars border rounded-sm" id="collapse-5">
                            <div class="list-group list-custom-small">
                                <a class="a-reminderCalendars" v-for="c in reminderCalendars" :key="c.tempId" :class="{'disabledSpan':c.passed}">
                                    <div class="d-flex align-items-center">
                                        <i class="fa font-14 fa-calendar-check rounded-sm shadow-m bg-yellow1-dark"></i>
                                        <span v-show="c.edit == false || c.passed" @click="onClickCalendarLable(c)">{{c.calendarDateTime}}</span>
                                        <input class="reminderCalendarInput"
                                               v-model="c.calendarDateTime"
                                               v-show="c.edit==true && c.passed!=true"
                                               :id="'c'+c.tempId" />
                                        <span @click="onDateChanged(c)" v-show="c.edit==true && c.passed!=true" class="fa font-20 fa-check-square shadow-m mr-2 color-green1-dark"></span>

                                        <date-picker v-show="c.edit==true && c.passed!=true" type="date" v-model="c.calendarDateTime" format="jYYYY/jMM/jDD" :element="'c'+c.tempId" />

                                    </div>
                                    <div>
                                        <span class="badge bg-red2-dark font-10" v-if="c.isHoliday">تعطیل</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span :class="{'input-style-1-active' : reminderModel.description!==null}">توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>
                        <div class="collapse collapse-reminderCalendars" id="collapse-description">
                            <textarea v-model="reminderModel.description" class="form-control line-height-m text-justify rounded-sm" rows="2" style="height:200px" @input="v$.reminderModel.description.$touch()" :class="{invalid:v$.reminderModel.description.$error}"></textarea>
                            <p class="text-danger" v-if="v$.reminderModel.description.maxLength.$invalid && v$.reminderModel.description.$dirty">توضیحات نباید بیش از ۱۰۰۰ کاراکتر باشد..</p>

                        </div>
                    </div>

                    <!--<div class="input-style input-style-2 has-icon input-required">
        <i class="input-icon fa fa-pen color-magenta2-light"></i>
        <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.description!==null}">توضیحات</span>
        <textarea v-model="reminderModel.description" class="form-control line-height-m text-justify" rows="2" style="height:200px" @input="v$.reminderModel.description.$touch()" :class="{invalid:v$.reminderModel.description.$error}"></textarea>
        <p class="text-danger" v-if="v$.reminderModel.description.maxLength && v$.reminderModel.description.$dirty">توضیحات نباید بیش از ۱۰۰۰ کاراکتر باشد..</p>
    </div>-->

                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="EditReminder">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <date-picker type="date" v-model="reminderModel.startDate" format="jYYYY/jMM/jDD" element="startDT" @change="changeCalendar" />
        <date-picker type="date" v-model="reminderModel.endDate" format="jYYYY/jMM/jDD" element="endDT" @change="changeCalendar" />

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required,
        maxLength
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'


    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';

    export default {
        components: {
            DatePicker
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                changed: false,
                modified: false,
                reminderModel: {
                    taskId: null,
                    interval: null,
                    reminderRepeatTypeId: null,
                    reminderId: this.$route.params.reminderId,
                    startDate: null,
                    startTime: null,
                    endDate: null,
                    onHoliday: false,
                    onDayAfterHoliday: false,
                    title: null,
                    userId: 0,
                    description: null,
                    disabled: false,
                    reminderCalendars: [],
                    attList: [],
                    calendarErrorMsg: null,
                    leadId: null,

                    projectId: null,
                    invoiceId: null,
                    preInvoiceId: null,
                    contractId: null,
                    letterId: null,
                    personId: null,
                    meetingId: null,
                    preBuyInvoiceId: null,
                    buyId: null,

                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                    isLoad: false,
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            reminderTypeList() {
                return this.$store.getters.GetReminderTypeList;
            },
            reminderCalendars() {
                return this.$store.getters.GetReminderCalendarList;
            },
            hasTaskId() {
                return this.reminderModel.taskId != null
            },
            localUserListList() {
                //document.getElementById("XXX").style.display = "block";
                return this.$store.getters.GetLocalUserListList;
            }


            ,
            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        },
        created() {
            this.$store.dispatch("CheckUserSMS");
            this.$store.dispatch("GetReminderTypeListFromServer")
            this.getReminderItem();
            setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); })
            this.getUserList();
            //document.getElementById("XXX").style.display = "block";
        },
        watch: {
            'reminderModel.personId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangePerson();
            },
            'reminderModel.projectId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangeProject();
            },
            'reminderModel.preInvoiceId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangePreInvoice();
            },
            'reminderModel.contractId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangeContract();
            },
            'reminderModel.meetingId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangeMeeting();
            },
            'reminderModel.invoiceId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangeInvoice();
            },
            'reminderModel.letterId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangeLetter();
            },
            'reminderModel.buyId'(value) {
                if (this.reminderModel.isLoad)
                    this.onchangeBuy();
            },
        },
        methods: {
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.reminderModel.projectId = null;
                this.reminderModel.invoiceId = null;
                this.reminderModel.preInvoiceId = null;
                this.reminderModel.contractId = null;
                this.reminderModel.letterId = null;
                this.reminderModel.meetingId = null;
                this.reminderModel.preBuyInvoiceId = null;
                this.reminderModel.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.reminderModel.contractId = null;
                this.reminderModel.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.reminderModel.personId,
                    projectId: this.reminderModel.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.reminderModel.personId,
                    projectId: this.reminderModel.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                        projectId: this.reminderModel.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.reminderModel.contractId = null;
                this.reminderModel.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.reminderModel.preInvoiceId,
                    contractId: this.reminderModel.contractId,
                    personId: this.reminderModel.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.reminderModel.invoiceId = null;
                this.reminderModel.buyId = null;
                this.reminderModel.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.reminderModel.preInvoiceId,
                    contractId: this.reminderModel.contractId,
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.reminderModel.personId,
                    projectId: this.reminderModel.projectId,
                    contractId: this.reminderModel.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.reminderModel.personId,
                    prebuyInvoiceId: this.reminderModel.prebuyInvoiceId,
                    contractId: this.reminderModel.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.reminderModel.preInvoiceId,
                        contractId: this.reminderModel.contractId,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                        contractId: this.reminderModel.contractId,
                        projectId: this.reminderModel.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                        prebuyInvoiceId: this.reminderModel.prebuyInvoiceId,
                        contractId: this.reminderModel.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },

            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    expiredControl: true
                });
                setTimeout(function () {
                    document.querySelectorAll("#XXX").forEach(a => a.style.display = "block");
                }, 1000)
            },
            calcCalendar() {
                this.$store.dispatch("GetReminderCalendarListFromServer", {
                    reminderId: this.reminderModel.reminderId,
                    startDate: this.reminderModel.startDate,
                    endDate: this.reminderModel.endDate,
                    interval: this.reminderModel.interval,
                    typeId: this.reminderModel.reminderRepeatTypeId,
                    isChanged: this.changed
                }).then(x => {
                    this.reminderModel.isLoad = true;
                });
            },
            changeCalendar() {
                this.changed = true;
                this.calcCalendar();
            },
            EditReminder() {
                if (this.calendarErrorMsg != null) {
                    this.showErrorMessage(this.calendarErrorMsg);
                    return;
                }
                this.reminderModel.reminderCalendars = this.reminderCalendars;
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.$store.dispatch("EditReminder", this.reminderModel);
                }

            },
            getIsHoliday(c) {
                this.$http.get("Reminder/IsHoliday?date=" + c.calendarDateTime)
                    .then(data => {
                        if (data.data == true) {
                            c.isHoliday = true;
                        }
                        else {
                            c.isHoliday = false;
                        }
                    });

            },
            getReminderItem() {
                this.$http.get("Reminder/GetById?id=" + this.$route.params.reminderId)
                    .then(data => {
                        this.$store.dispatch("GetPersonListFromServer", {
                            text: "",
                            personId: data.data.personId,
                        }).then(a => {

                            this.$store.dispatch("GetProjectListFromServer", {
                                text: "",
                                personId: data.data.personId,
                                projectId: data.data.projectId,
                            }).then(b => {
                                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                                    text: "",
                                    personId: data.data.personId,
                                    preInvoiceId: data.data.preInvoiceId,
                                }).then(c => {
                                    this.$store.dispatch("GetContractAbstractForPerson", {
                                        personId: data.data.personId,
                                        projectId: data.data.projectId,
                                        contractId: data.data.contractId,
                                    }).then(d => {
                                        this.$store.dispatch("GetInvoiceAbstractForPerson", {
                                            invoiceId: data.data.invoiceId,
                                            preInvoiceId: data.data.preInvoiceId,
                                            contractId: data.data.contractId,
                                            personId: data.data.personId,
                                        }).then(e => {
                                            this.$store.dispatch("GetLetterAbstractForPerson", {
                                                letterId: data.data.letterId,
                                                personId: data.data.personId,
                                            }).then(f => {
                                                this.$store.dispatch("GetMeetingAbstractForPerson", {
                                                    personId: data.data.personId,
                                                    contractId: data.data.contractId,
                                                    projectId: data.data.projectId,
                                                    meetingId: data.data.meetingId,
                                                }).then(g => {
                                                    this.$store.dispatch("GetBuyAbstractForPerson", {
                                                        personId: data.data.personId,
                                                        prebuyInvoiceId: data.data.prebuyInvoiceId,
                                                        buyId: data.data.buyId,
                                                        contractId: data.data.contractId,
                                                    }).then(h => {
                                                        this.$store.dispatch("GetLocalUserListListFromServer", {
                                                            expiredControl: true
                                                        }).then(j => {
                                                            this.reminderModel = data.data;                                       
                                                            this.calcCalendar();

                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                        this.modified = false
                    });





            },
            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        var m = data.data.split("_")
                        this.reminderModel.startDate = m[0];
                        this.reminderModel.startTime = m[1];
                    });

            },

            SetAttList(e) {
                console.log(e);
                this.reminderModel.attList = e;
            },

            onClickCalendarLable(c) {
                if (c.passed == true) {
                    return;
                }
                var edited = this.reminderCalendars.filter(function (elem) {
                    if (elem.edit == true) return elem.tempId;
                });

                if (edited.length === 0) {
                    c.edit = true;
                    document.getElementById("c" + c.tempId).focus();
                }

            },
            onDateChanged(c) {
                if (c.passed != true) {
                    console.log(this.reminderCalendars.filter(x => x.calendarDateTime == c.calendarDateTime));
                    if (this.reminderCalendars.filter(x => x.calendarDateTime == c.calendarDateTime).length > 1) {
                        this.calendarErrorMsg = "تاریخ " + c.calendarDateTime + " تکرار شده است."
                        this.showErrorMessage(this.calendarErrorMsg);
                        return;
                    }
                    this.getIsHoliday(c);
                    c.edit = false;
                    this.calendarErrorMsg = null;
                }


            }

        },

        validations: {
            reminderModel: {
                interval: {
                    required,
                },

                title: {
                    required,
                    maxLength: maxLength(150)
                },
                reminderRepeatTypeId: {
                    required
                },
                startDate: {
                    required
                },
                startTime: {
                    required
                },
                description: {
                    maxLength: maxLength(1000)
                },

            }


        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }

    };
</script>
<style>
    .disabledSpan {
        margin-left: -7px;
        padding-right: 20px;
        background-color: lightgray;
        margin-right: -15px;
    }
</style>
